<template>
  <modal-base
    title="Gesundheitsregionplus im Gesundheitsamt des Landkreises Roth"
    ref="modal"
  >
    <p>
      Einwilligungserklärung zur Verarbeitung personenbezogener Daten im
      Zusammenhang mit der Nutzung des online-Vermittlungsportals zur
      Vermittlung von Hebammen im Landkreis Roth gemäß Art. 6 Abs. 1 S. 1 lit. a
      DSGVO
    </p>
    <p>
      Hiermit willigen Sie in die Verarbeitung der im Antragsformular erhobenen
      personenbezogenen Daten zur Vermittlung einer Hebamme im Rahmen des
      online-Services des Landratsamtes Roth ein. Die Verarbeitung ist
      erforderlich, um eine Vermittlung von Hebammen im Rahmen des
      online-Vermittlungsportals durchführen zu können.
    </p>
    <p>
      Eine Weitergabe der Daten erfolgt an die Hebammen, welche Leistungen im
      Landkreis Roth anbieten. Die Daten werden zudem in anonymisierter und
      entpersonalisierter Form für eine Auswertung im Landratsamt Roth
      verwendet, um die Nutzung des Portals zu analysieren.
    </p>
    <p>
      Für den Fall der Nichteinwilligung kann eine Vermittlung einer Hebamme
      über das zur Verfügung gestellte online-Vermittlungsportal nicht erfolgen.
    </p>
    <p>
      Ihre Einwilligung ist jederzeit für die Zukunft widerrufbar. Der Widerruf
      ist zu erklären gegenüber dem Landratsamt Roth und zu senden an
    </p>
    <ul>
      <li>per Post: Landratsamt Roth, Weinbergweg 1, 91154 Roth</li>
      <li>per E-Mail: datenschutz@landratsamt-roth.de</li>
    </ul>
    <p>
      Bitte haben Sie dafür Verständnis, dass Einwilligungen aus Gründen der
      Dokumentation und Nachvollziehbarkeit nicht mündlich widerrufen werden
      können.
    </p>
    <p>
      Ihnen ist bekannt, dass Ihre Einwilligung Voraussetzung für den zuvor
      genannten Verwendungszweck ist und Sie diese jederzeit mit Wirkung für die
      Zukunft widerrufen können. Die Rechtmäßigkeit der aufgrund der
      Einwilligung bis zum Widerruf erfolgten Datenverarbeitung wird durch
      diesen nicht berührt.
    </p>
    <p>Hinweis zur Einwilligung bei Minderjährigen unter 16 Jahren:</p>
    <p>
      Bei einer Verarbeitung personenbezogener Daten von Minderjährigen unter 16
      Jahren ist zusätzlich die Einwilligung des/der Erziehungsberechtigten
      erforderlich.
    </p>
    <p>
      Hiermit haben Sie die Einwilligungserklärung zur Verarbeitung
      personenbezogener Daten im Zusammenhang mit der Nutzung des
      online-Vermittlungsportals zur Vermittlung von Hebammen im Landkreis Roth
      zur Kenntnis genommen und sind mit der Verarbeitung einverstanden.
    </p>
  </modal-base>
</template>

<script>
import ModalBase from "./ModalBase";
import { modalBaseMixin } from "../../mixins/modalBase";
export default {
  name: "TermsOfServiceModal",
  components: { ModalBase },
  mixins: [modalBaseMixin]
};
</script>

<style scoped></style>
